<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">VM 목록</div>
        <div class="mr-r4">
          가상화센터명
          <el-select v-model="selectedVirtualcenter" value-key="virtualcenterGroupId" @change="loadTableData">
            <el-option v-for="item in virtualcenterList" :key="item.virtualcenterGroupId" :label="item.label" :value="item"></el-option>
          </el-select>
        </div>
        <!-- <el-button size="mini">VM 생성</el-button> -->
      </div>
      <div class="vertical-center-box">
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper row-class-name="c-dblclick" :data="tableData" :columns="tableColumns" :column-default="columnDefault" ref="vmTable" :pagination="true" :show-search-tool="showSearchTool"
       :show-custom-header="true" @condition-change="loadTableData" @selection-change="changeCheckedRow" remote :total="total" @row-dblclick="onRowDblClick">
       <template slot-scope="scope" slot="action-button-slot">
        <i class="far fa-edit text-large c-pointer mr-r8" style="color:#606266" @click="onRowDblClick(scope.row)"></i>
        <i class="far fa-trash-alt text-large c-pointer mr-r8" style="color:#606266" @click="onClickVmDelete(scope.row)" v-if="scope.row.hypervisorType === 'VMWARE' || scope.row.hypervisorType ==='XENSERVER' || scope.row.hypervisorType ==='HyperV'"></i>
        <i class="fas fa-exchange-alt text-large c-pointer" style="color:#606266" @click="onClickVmConvert(scope.row)" v-if="scope.row.hypervisorType === 'VMWARE' || scope.row.hypervisorType ==='XENSERVER'"></i>
       </template>
      </el-table-wrapper>
    </el-row>
    <w-vm-management-setting-popup ref="vmManagementSettingPopupRef" @load-data="loadData"></w-vm-management-setting-popup>
    <w-virtual-vm-convert-popup ref="virtualVmConvertPopup" popup-type="setting" :obj-info="covertObjInfo"></w-virtual-vm-convert-popup>
  </div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import DeviceRegistrationVmsAPI from '@/api/settings/common/device-registration-vms';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import WVirtualVmConvertPopup from '@/views/performance/node/popup/components/VirtualVmConvertPopup';
import WVmManagementSettingPopup from '../popup/VmManagementSettingPopup';

export default {
  name: 'WVmManagement',
  components: {
    WVmManagementSettingPopup,
    WVirtualVmConvertPopup,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      virtualcenterList: [],
      selectedVirtualcenter: null,
      columnDefault,
      showSearchTool: false,
      isLoading: false,
      total: 0,
      checkedRows: [],
      tableData: [],
      vmSettingParams: {},
      covertObjInfo: null,
      tableColumns: [
        {
          prop: 'VVM_COMMON/ALIVE',
          label: '전원 상태',
          formatter: this.getTableValueAfterCheckEmpty,
          width: 100,
          filters: [
            {
              text: '켜짐',
              value: '켜짐',
            },
            {
              text: '꺼짐',
              value: '꺼짐',
            },
          ],
        },
        {
          prop: 'vmName',
          label: 'VM 명',
          searchable: true,
        },
        {
          prop: 'vmDesc',
          label: '별칭',
          formatter: this.getTableValueAfterCheckEmpty,
          width: 200,
          searchable: true,
        },
        {
          prop: 'VVM_COMMON/OS',
          label: '운영체제',
          formatter: this.getTableValueAfterCheckEmpty,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          formatter: this.getTableValueAfterCheckEmpty,
          width: 200,
          searchable: true,
        },
        {
          prop: 'VVM_COMMON/CPU_CORE_TOTAL_COUNT',
          label: 'CPU',
          formatter: (row, column, value) => this.convertTableValuByUnit(value, ''),
          width: 100,
        },
        {
          prop: 'VVM_MEM/TOTAL_CAPACITY',
          label: '메모리',
          formatter: (row, column, value) => this.convertTableValuByUnit(value, 'MB'),
          width: 100,
        },
        {
          prop: 'VVM_DISK/TOTAL_CAPACITY',
          label: '디스크',
          formatter: (row, column, value) => this.convertTableValuByUnit(value, 'MB'),
          width: 100,
        },
        {
          prop: 'mainVmUserId',
          label: '사용자',
          formatter: this.getTableValueAfterCheckEmpty,
          searchable: true,
        },
        {
          prop: 'expireDate',
          label: '만료 시각',
          formatter: this.getDateFormatter,
          searchable: true,
          searchType: 'date',
        },
        {
          label: '수행',
          width: 90,
          scopedSlot: 'action-button-slot',
        },
      ],
    };
  },
  methods: {
    loadData() {
      const cmpName = this.$options.name;
      if (this.activeTab === cmpName) {
        DeviceRegistrationVmsAPI.getVirtualCenterList().then((response) => {
          this.virtualcenterList = response.data.data;
          if (this.virtualcenterList.length > 0) {
            this.selectedVirtualcenter = this.virtualcenterList[0];
            this.loadTableData();
          }
        });
      }
    },
    loadTableData() {
      const tableParams = this.$refs.vmTable.getParameter();
      const params = { virtualcenterGroupId: this.selectedVirtualcenter.virtualcenterGroupId, objtypeId: 'VVM', templateFlag: '0', vmsObjDeleted: '0' };
      this.isLoading = true;
      DeviceRegistrationVmsAPI.getVirtualObjList({
        attrInfoParams: [
          { attrTypeId: 'VVM_COMMON', attrId: 'ALIVE' },
          { attrTypeId: 'VVM_COMMON', attrId: 'OS' },
          { attrTypeId: 'VVM_COMMON', attrId: 'CPU_CORE_TOTAL_COUNT' },
          { attrTypeId: 'VVM_MEM', attrId: 'TOTAL_CAPACITY' },
          { attrTypeId: 'VVM_DISK', attrId: 'TOTAL_CAPACITY' },
        ],
        ...params,
        ...tableParams,
      }).then((response) => {
        this.total = response.data.total;
        this.tableData = response.data.data;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    /**
     * 데이터 포맷터
     * @author jeee12
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value, 'YYYY-MM-DD');
      }
      return EMPTY_TEXT;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    convertTableValuByUnit(value, unit) {
      if (value === '' || isNil(value)) {
        return EMPTY_TEXT;
      } else if (unit === 'MB') {
        return `${convertValuByUnit(value, unit, true, true, true)}B`;
      }
      return `${convertValuByUnit(value, unit, true, true, true)}`;
    },
    onRowDblClick(row) {
      this.$refs.vmManagementSettingPopupRef.open(row, { expireDate: row.expireDate, mainVmUserId: row.mainVmUserId });
    },
    onClickVmDelete(row) {
      const messageOptions = {
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
        showClose: false,
      };
      const target = 'VM';
      const action = msgUtil.action.DELETE;
      this.$confirm('해당 VM을 삭제하는데는 약간의 시간이 소요됩니다.<br />삭제하시겠습니까?', '확인', messageOptions).then(() => {
        DeviceRegistrationVmsAPI.discardRealVm(row).then((response) => {
          const result = response.data;
          if (result.success) {
            this.$message(msgUtil.getResultMsgData(action, target, result.success));
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        });
      }).catch(() => {});
    },
    onClickVmConvert(row) {
      const objInfo = row;
      const obj = {
        objId: objInfo.objId,
      };
      objInfo.obj = obj;
      this.covertObjInfo = cloneDeep(objInfo);
      this.$nextTick(() => {
        this.$refs.virtualVmConvertPopup.open();
      });
    },
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/components/VmManagement.vue